import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Box from "@mui/material/Box";
import "./Layout.scss";

type PropType = {
  app: string;
}
const Layout = (props: PropType) => {
  return (
    <div className="dashboard-layout">
      <Box className="dashboard-layout-frame">
        <Box
          component="main"
          className="dahboard-layout-main"
        >
          <Header app={props.app} />
          <Box
            className="content"
            sx={{
              backgroundColor: "#fff",
              marginTop: `20px`,
            }}
          >
            <Outlet />
          </Box>
          <Footer />
        </Box>
      </Box>
    </div>
  );
};

export default Layout;
